import '../styles/Navigation.css';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleScroll = () => {
    setScrolled(window.scrollY > 0);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav
      className={`navbar navbar-expand-md fixed-top px-3 ${
        scrolled ? 'bg-light shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="container-fluid">
        <Link className={`navbar-brand fw-bold ${scrolled ? 'text-dark' : 'text-white'}`} to="/">
          Gerrit Helm
        </Link>
        <button
          className="navbar-toggler border-0"
          type="button"
          onClick={toggleMobileMenu}
        >
          <span className={`navbar-toggler-icon ${scrolled ? '' : 'navbar-dark'}`}></span>
        </button>

        <div className={`collapse navbar-collapse justify-content-center ${menuOpen ? 'show bg-white mobile-menu-custom' : ''}`}>
            <ul className="navbar-nav nav-center">
                <li className="nav-item">
                <Link className={`nav-link ${scrolled ? 'text-dark' : 'text-white'} fs-5`} to="/about">
                    Zur Person
                </Link>
                </li>
                <li className="nav-item">
                <Link className={`nav-link ${scrolled ? 'text-dark' : 'text-white'} fs-5`} to="/publikationen">
                    Publikationen
                </Link>
                </li>
                <li className="nav-item">
                <Link className={`nav-link ${scrolled ? 'text-dark' : 'text-white'} fs-5`} to="/news">
                    Aktuelles
                </Link>
                </li>
                <li className="nav-item">
                <Link className={`nav-link ${scrolled ? 'text-dark' : 'text-white'} fs-5`} to="/projekte">
                    Projekte
                </Link>
                </li>
                <li className="nav-item">
                <Link className={`nav-link ${scrolled ? 'text-dark' : 'text-white'} fs-5`} to="/impressum">
                    Impressum
                </Link>
                </li>
            </ul>
            </div>
      </div>
    </nav>
  );
}

export default Navigation;
